import createAccountSaga from "./createAccount.saga";
import sendLoginOTPSaga from "./sendLoginOTP.saga";
import verifyAccountSaga from "./verifyAccount.saga";
import verifyLoginOTPSaga from "./verifyLoginOTP.saga";
import fetchAccessTokenSaga from './getAccessToken.saga';

const AuthSaga = [
    createAccountSaga(),
    sendLoginOTPSaga(),
    verifyAccountSaga(),
    verifyLoginOTPSaga(),
    fetchAccessTokenSaga()
]

export default AuthSaga;